module Hereabout.Types where

import Prelude

import Data.DateTime (DateTime(..))
import Data.Maybe (Maybe)
import Data.Newtype (class Newtype)


newtype GeoPosition = GeoPosition
  { latitude :: Number
  , longitude :: Number
  }

derive instance eqGeoPosition :: Eq GeoPosition
derive instance ordGeoPosition  :: Ord GeoPosition

newtype Address = Address
  { addressLine1 :: String
  , addressLine2 :: Maybe String
  , addressLine3 :: Maybe String
  , addressLocality :: String
  , addressCounty :: Maybe String
  , addressPostalCode :: String
  , addressCountry :: Maybe String
  }

derive instance eqAddress :: Eq Address
derive instance ordAddress :: Ord Address

newtype Venue = Venue
  { name :: String
  , id :: String
  , content :: Content
  , address :: Address
  , boundaries :: String
  , image :: Maybe String
  , phoneNumber :: Maybe String
  , website :: Maybe String
  }

derive instance eqVenue :: Eq Venue
derive instance orVenue :: Ord Venue

data Place
  = GPSPosPlace GeoPosition
  | VenuePlace Venue
  
derive instance eqPlace :: Eq Place
derive instance ordPlace :: Ord Place

data Content
  = ParagraphsContent (Array String)
  | MarkdownContent String
  | HTMLContent String

derive instance eqContentType :: Eq Content
derive instance ordContentType :: Ord Content

newtype EventType = EventType
  { name :: String
  , icon :: Maybe String
  , image :: Maybe String
  }

derive instance eqEventType :: Eq EventType
derive instance ordEventType :: Ord EventType

newtype Event = Event
  { name :: String
  , id :: String
  , content :: Content
  , timestamp :: DateTime
  , duration :: Int
  , place :: Place
  , type :: Maybe EventType
  , signupUrl :: Maybe String
  , image :: Maybe String
  , commentCount :: Int
  , favouriteCount :: Int
  }

derive instance eqEvent :: Eq Event
derive instance ordEvent :: Ord Event

newtype VenueFeed = VenueFeed
  { name :: String
  , id :: String
  , content :: Content
  , address :: Address
  , events :: Array Event
  , image :: Maybe String
  , boundaries :: String
  , phoneNumber :: Maybe String
  , website :: Maybe String
  }


newtype CommunityFeed = CommunityFeed
  { name :: String
  , id :: String
  , content :: Content
  , events :: Array Event
  , venues :: Array Venue
  , image :: Maybe String
  , repoUrl :: String
  }

newtype CommunityDetails = CommunityDetails
  { communityId :: String
  , name :: String
  , image :: Maybe String
  , content :: Content
  }

newtype AreaCommunityDetails = AreaCommunityDetails
  { acdAreaId :: String
  , acdAreaName :: String
  , acdAreaCommunities :: Array CommunityDetails
  }

newtype User = User
  { id :: String
  , fullName :: String
  , imageUrl :: String
  }

derive instance eqUserType :: Eq User
derive instance ordUserType :: Ord User

newtype Unsantised = Unsantised -- used as a typesafe way of capturing markdown before it has been DOM sanitised and converted to safe html
  { data :: String
  }

newtype Comment a = Comment
  { id :: String
  , user :: User
  , content :: a
  , timestamp :: DateTime
  }

derive instance eqMessageType :: Eq a => Eq (Comment a)
derive instance ordMessageType :: Ord a => Ord (Comment a)

newtype EventWithComments a = EventWithComments
  { name :: String
  , id :: String
  , content :: Content
  , timestamp :: DateTime
  , duration :: Int
  , place :: Place
  , type :: Maybe EventType
  , signupUrl :: Maybe String
  , image :: Maybe String
  , eventInstances :: Array DateTime
  , comments :: Array (Comment a)
  , favouriteCount :: Int
  , isFavourite :: Maybe Boolean
  }

derive instance eqEventWithMsg :: Eq a => Eq (EventWithComments a)
derive instance ordEventWithMsg :: Ord a => Ord (EventWithComments a)

newtype PostComment = PostComment
  { content :: String
  }

